var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentElement,{key:_vm.currentKey,tag:"component",attrs:{"el":_vm.el,"custom-mode":_vm.customMode,"document":_vm.document,"recipient":_vm.recipient},on:{"end-drag":_vm.onDragEnd,"remove-drag":_vm.onRemove,"on-selected":_vm.OnRender}})
}
var staticRenderFns = []

export { render, staticRenderFns }